<template>
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
		stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="M23 18l-9.5-9.5-5 5L1 6" />
		<path d="M17 18h6v-6" />
	</svg>
</template>

<script>
// Mismo icono usado por Costos y Gastos (idéntico al SVG inline original).
// Si se diferencia uno de otro en el futuro, crear IconExpenses.vue.
export default {
	name: "IconCosts",
};
</script>
